import { useEffect, useState } from "react";

import { NavLink } from "react-router-dom";

import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  TabContent,
  TabPane,
} from "reactstrap";

//Util
import { ICONES_BOTAO } from "@/frontend/utils/icones";
import { fn_montarConferenciasPagamentos } from "@/frontend/utils/siig/solicitacao";

//API
import { api_listar, ROTA_LISTAR } from "@/frontend/services/api/api_list";

//Telas
import TSolicitacao_det_aba_ident from "./solicitacao_det_aba_ident";
import TSolicitacao_det_aba_contrato from "./solicitacao_det_aba_contrato";
import TSolicitacao_det_aba_pag from "./solicitacao_det_aba_pag";
import TSolicitacao_det_aba_aprov from "./solicitacao_det_aba_aprov";
import TSolicitacao_det_aba_conferencias from "./solicitacao_det_aba_conferencias";
import TSolicitacao_det_aba_anexos from "./solicitacao_det_aba_anexos";

function TSolicitacao_det({ modalOpen, toggleModal, solicitacao, numPag }) {
  //### USE STATE ###
  const [activeTab, setActiveTab] = useState("1");

  //Conferências de todos os pagamentos da solicitação (aba Conferências)
  const [conferencias, setConferencias] = useState([]);

  //### USE EFFECT ###
  //Inicialização da tela
  useEffect(() => {
    //Carrega as conferências de todos os pagamentos da solicitação
    async function loadConferencias() {
      const pagamentos =
        solicitacao.pagamentos ||
        (await api_listar(
          ROTA_LISTAR.PAGAMENTOS_SOLICITACAO,
          `id_solicitacao=${solicitacao.id}`,
        ));

      if (pagamentos?.length > 0) {
        const conferenciasPag = await api_listar(
          ROTA_LISTAR.SOLICITACAO_PAG_CONFERENCIA,
          `id_solicitacao_pag=${pagamentos.map((pag) => pag.id).join(",")}`,
        );

        setConferencias(
          fn_montarConferenciasPagamentos(pagamentos, conferenciasPag),
        );
      }
    }

    loadConferencias();
  }, []);

  return (
    <Modal isOpen={modalOpen} backdrop="static" size="xxl">
      <ModalHeader toggle={toggleModal} className="titulo-tela-modal">
        Solicitação {solicitacao.numero}
      </ModalHeader>

      <ModalBody>
        <div className="m-1">
          <Nav tabs>
            <NavItem className="tabBorda">
              <NavLink
                className={activeTab == "1" ? "tabAtivaNome" : "tabNome"}
                onClick={() => setActiveTab("1")}
              >
                Solicitação
              </NavLink>
            </NavItem>

            {solicitacao.possui_contrato == "S" && (
              <NavItem className="tabBorda">
                <NavLink
                  className={activeTab == "2" ? "tabAtivaNome" : "tabNome"}
                  onClick={() => setActiveTab("2")}
                >
                  Contrato
                </NavLink>
              </NavItem>
            )}

            <NavItem className="tabBorda">
              <NavLink
                className={activeTab == "3" ? "tabAtivaNome" : "tabNome"}
                onClick={() => setActiveTab("3")}
              >
                Pagamentos ({solicitacao.qtde_pagamentos})
              </NavLink>
            </NavItem>

            {solicitacao.aprovacoes.length > 0 && (
              <NavItem className="tabBorda">
                <NavLink
                  className={activeTab == "4" ? "tabAtivaNome" : "tabNome"}
                  onClick={() => setActiveTab("4")}
                >
                  Aprovações ({solicitacao.aprovacoes.length})
                </NavLink>
              </NavItem>
            )}

            {/* Conferências de todos os pagamentos */}
            {conferencias.length > 0 && (
              <NavItem className="tabBorda">
                <NavLink
                  className={activeTab == "7" ? "tabAtivaNome" : "tabNome"}
                  onClick={() => setActiveTab("7")}
                >
                  Conferências ({conferencias.length})
                </NavLink>
              </NavItem>
            )}

            {solicitacao.anexos.length > 0 && (
              <NavItem className="tabBorda">
                <NavLink
                  className={activeTab == "5" ? "tabAtivaNome" : "tabNome"}
                  onClick={() => setActiveTab("5")}
                >
                  Anexos ({solicitacao.anexos.length})
                </NavLink>
              </NavItem>
            )}
          </Nav>

          {/* CONTEÚDO DAS ABAS */}
          <div className="scroll-modal-fixed-max">
            <TabContent activeTab={activeTab}>
              {/* ABA SOLICITAÇÃO */}
              <TabPane tabId="1">
                <TSolicitacao_det_aba_ident solicitacao={solicitacao} />
              </TabPane>

              {/* ABA CONTRATO */}
              {solicitacao.possui_contrato == "S" && (
                <TabPane tabId="2">
                  <TSolicitacao_det_aba_contrato solicitacao={solicitacao} />
                </TabPane>
              )}

              {/* ABA PAGAMENTOS */}
              <TabPane tabId="3">
                <TSolicitacao_det_aba_pag
                  solicitacao={solicitacao}
                  numPag={numPag}
                />
              </TabPane>

              {/* ABA APROVAÇÕES */}
              {solicitacao.aprovacoes.length > 0 && (
                <TabPane tabId="4">
                  <TSolicitacao_det_aba_aprov solicitacao={solicitacao} />
                </TabPane>
              )}

              {/* ABA CONFERÊNCIAS (de todos os pagamentos) */}
              {conferencias.length > 0 && (
                <TabPane tabId="7">
                  <TSolicitacao_det_aba_conferencias
                    solicitacao={solicitacao}
                    conferencias={conferencias}
                  />
                </TabPane>
              )}

              {/* ABA ANEXOS */}
              {solicitacao.anexos.length > 0 && (
                <TabPane tabId="5">
                  <TSolicitacao_det_aba_anexos solicitacao={solicitacao} />
                </TabPane>
              )}
            </TabContent>
          </div>
        </div>
      </ModalBody>

      <ModalFooter>
        <Button name="btnFechar" color="secondary" onClick={toggleModal}>
          {ICONES_BOTAO.FECHAR} Fechar
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default TSolicitacao_det;
